import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { UUID } from '../models/utils.type'

@Injectable()
export class AsyncTasksService {
  private readonly http = inject(HttpClient)

  private readonly baseUrl = 'rest/async-tasks'

  public ack(asyncTaskId: UUID): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/ack/${asyncTaskId}`, {})
  }
}
